import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ExpandedStatusService {
  activedExapandedRow: any[] = [];
  constructor() {}
}
